'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var button = require('./button-c50f4784.js');

var Block = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var Title = styled__default.p(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font-size: ", ";\n  line-height: 24px;\n  font-weight: 500;\n  font-family: ", ";\n  margin-bottom: 4px;\n"], ["\n  font-size: ", ";\n  line-height: 24px;\n  font-weight: 500;\n  font-family: ", ";\n  margin-bottom: 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizes.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var StyledButton = styled__default(button.Button)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  height: 36px;\n  border-color: ", ";\n  color: ", ";\n"], ["\n  height: 36px;\n  border-color: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.darkGrey6;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.darkGrey6;
});
var templateObject_1, templateObject_2, templateObject_3;

exports.Block = Block;
exports.StyledButton = StyledButton;
exports.Title = Title;
